import { bounceIn } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { Button } from './Button';
import { TertiaryButtonProps } from './ButtonProps';
import styles from './ClearButton.module.css';

type ClearButtonProps = Omit<TertiaryButtonProps, 'danger'> & {
  hasError?: boolean;
};

export function ClearButton({
  className,
  onClick,
  size = 'small',
  icon = 'exit',
  iconSize,
  label = i18n('common.clear'),
  hasError,
  ...props
}: ClearButtonProps) {
  return (
    <Button
      className={[styles.clearButton, bounceIn, className, hasError && styles.hasError]}
      onClick={onClick}
      variant="tertiary"
      icon={icon}
      iconSize={iconSize}
      iconOnly
      label={label}
      size={size}
      {...props}
    />
  );
}
